import { render, staticRenderFns } from "./TedsLauncherLinkCard.vue?vue&type=template&id=8df060f4&scoped=true&"
import script from "./TedsLauncherLinkCard.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherLinkCard.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherLinkCard.vue?vue&type=style&index=0&id=8df060f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df060f4",
  null
  
)

export default component.exports